import React from 'react';

import agentIcon from "../../assets/security/agent.png";
import serverIcon from "../../assets/security/server.png";

const TrueEPSupportEnv = ({ styles }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>지원환경</h2>
      <div className={styles.divider} />

      <div className={styles.env}>
        <div className={styles.envBox}>
          <div className={styles.envIcon}>
            <img src={agentIcon} alt="agent icon" className={styles.envIconImg} draggable={false} />
          </div>
          <div>
            <div className={styles.envTitle}>에이전트 (32/64bits 지원)</div>
            <div className={styles.envText}>Windows 2000XP / Windows VISTA</div>
            <div className={styles.envText}>Windows 7 / Windows 8 / Windows 10</div>
          </div>
        </div>

        <div className={styles.envBox}>
          <div className={styles.envIcon}>
            <img src={serverIcon} alt="server icon" className={styles.envIconImg} draggable={false} />
          </div>
          <div>
            <div className={styles.envTitle}>관제서버 (32/64bits 지원)</div>
            <div className={styles.envText}>Windows 10</div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TrueEPSupportEnv